export function handleChunkError(err: any) {
    const isChunkError =
        err?.name === 'ChunkLoadError' || /Loading chunk .* failed/i.test(err?.message);
    const isFailedToFetch = err?.name === 'TypeError' && /Failed to fetch/i.test(err?.message);

    if (isChunkError || isFailedToFetch) {
        window.location.href = '/explore/service_unavailable';
        return;
    }

    throw err;
}
